import { FC } from 'react';

import { useActiveChannel } from '~/context/PartnerConfigContext';
import { MarketplaceChannel } from '~/types/marketplace';

import { NeedHelp } from '../need-help';

import { PromoBanner } from './promotion-banner';

type InterstitialBannerProps = {
  channel: MarketplaceChannel | null;
  code?: string;
};

const InterstitialBanner: FC<InterstitialBannerProps> = ({ channel, code }) => {
  const activeChannel = useActiveChannel();

  if (code) {
    return <PromoBanner code={code} channel={channel} />;
  }

  // The Need Help panel is opt-in per channel; hidden unless the channel enables it.
  if (!activeChannel?.showNeedHelpPanel) {
    return null;
  }

  return <NeedHelp />;
};

export { InterstitialBanner };
